<!--图片管理-->
<template>
  <page-view title="系统内容管理">
    <template slot="action">
      <a-button type="primary" v-if="isScmAdmin ||  actionType === ACTION_TYPE.system"
                @click="onAdd()">添加内容
      </a-button>
    </template>
    <a-card class="mb-3">
      <a-form-model :form="queryForm" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }"
                    class="exi_form v2">
        <a-form-model-item label="内容名称">
          <a-input v-model="queryForm.contentName"
                   style="width:300px"
                   @pressEnter="onSearch()"/>
        </a-form-model-item>
        <a-form-model-item label="内容标识">
          <a-input v-model="queryForm.contentKey"
                   style="width:300px"
                   @pressEnter="onSearch()"/>
        </a-form-model-item>
        <a-form-model-item label="内容类型" v-if="actionType === ACTION_TYPE.system">
          <dict-radio v-model="queryForm.contentType"
                      dictKey="sys_content_mange_type"
                      placeholder="内容类型"
                      @change="(val) => { queryForm.contentType = val }"/>
        </a-form-model-item>
        <a-button type="primary"
                  @click="onSearch()">查询
        </a-button>
        <a-button
            @click="onReset()">重置
        </a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table ref="contentTable"
               :rowKey="(record) => record.id"
               :columns="getColumns"
               :data="loadData"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }">
        <template v-slot:contentResource="record">
          <viewer v-if="record.contentType==='1'">
          <img :src="record.contentResource"
               style="width:100px;height:100px;cursor:pointer;"
               ></viewer>
          <span v-else>{{ record.contentResource }}</span>
        </template>
        <template v-slot:contentType="text">
          <a-tag v-if="text==='1'"
                 color="blue">图片
          </a-tag>
          <a-tag v-else
                 color="purple">文字
          </a-tag>
        </template>
        <template v-slot:action="text,record">
          <a @click="onEdit(record)">编辑</a>
          <template v-if="actionType === ACTION_TYPE.system || isSysAdmin">
            <a-divider type="vertical"/>
            <a-popconfirm title="是否确认删除?"
                          @confirm="onDelete(record)">
              <a href="#"
                 style="color:red;">删除</a>
            </a-popconfirm>
          </template>
        </template>
      </s-table>
    </a-card>
    <sys-content-mange-edit-model ref="contentEdit"
                                  :actionType="actionType"
                                  :visible="modalVisible"
                                  @cancel="modalVisible = false"
                                  @success="onContentSave"/>
    <a-modal :visible="previewVisible"
             :footer="null"
             :dialog-style="{ top: '20px' }"
             width="70%"
             @cancel="handlePreviewCancel">
      <img alt="example"
           style="width: 100%"
           :src="contentResource"/>
    </a-modal>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import SysContentMangeEditModel from './SysContentMangeEditModel'
import DictRadio from '@/components/dict/DictRadio'
import { DeleteById, QueryPageList } from '@/epp/sysContentMange/api/sysContentMangeApi'
import { ACTION_TYPE, IsScmAdmin } from '@/epp/sysContentMange/util/sysContentMangeUtil'
import { IsSysAdmin } from '@/epp/expertmain/userperm/UserPermUtil'

export default {
  name: 'SysContentMange',
  props: {
    actionType: {
      type: String,
      default: ACTION_TYPE.system
    }
  },
  components: { PageView, STable, SysContentMangeEditModel, DictRadio },
  data () {
    return {
      ACTION_TYPE,
      modalVisible: false,
      previewVisible: false,
      contentResource: undefined,
      columns: [
        { title: '内容名称', dataIndex: 'contentName' },
        { title: '内容标识', dataIndex: 'contentKey' },
        { title: '内容', scopedSlots: { customRender: 'contentResource' } },
      ],
      queryForm: {
        contentName: '',
        contentKey: '',
        contentType: ''
      },
      loadData: (parameter) => {
        const data = { ...parameter, ...this.queryForm, actionType: this.actionType }
        return QueryPageList(data)
      }
    }
  },
  computed: {
    getColumns () {
      if (ACTION_TYPE.system === this.actionType) {
        this.columns.push({
          title: '类型',
          width: '50px',
          dataIndex: 'contentType',
          scopedSlots: { customRender: 'contentType' }
        },)
      }
      return this.columns.concat([{ title: '备注', dataIndex: 'remark' },
        { title: '操作', width: '150px', scopedSlots: { customRender: 'action' } }])
    },
    // 是否是业务配置管理员
    isScmAdmin () {
      return IsScmAdmin()
    },
    // 是否是系统管理员
    isSysAdmin () {
      return IsSysAdmin()
    },

  },

  methods: {
    onSearch () {
      this.$refs.contentTable.refresh()
    },
    onReset () {
      this.queryForm = {
        contentName: '',
        contentKey: '',
        contentType: ''
      }
      this.$refs.contentTable.refresh(true)
    },
    onEdit (record) {
      this.modalVisible = true
      this.$refs.contentEdit.preEdit(record.id)
    },
    onAdd () {
      this.modalVisible = true
      this.$refs.contentEdit.preAdd()
    },
    onContentSave () {
      this.modalVisible = false
      this.$refs.contentTable.refresh()
    },
    async onDelete (record) {
      const res = await DeleteById(record)
      if (res.code === 200) {
        this.$message.success('删除成功')
        this.onSearch()
      } else {
        this.$message.error('删除失败')
      }
    },
    handlePreviewCancel () {
      this.previewVisible = false
      this.contentResource = ''
    },
    previewImg (base64Data) {
      this.previewVisible = true
      this.contentResource = base64Data
    }
  },
}
</script>

<style lang="less" scoped>
</style>
